(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var CLONES = 2;

  function centerX(el) {
    return el.offsetLeft + el.offsetWidth / 2;
  }

  function jumpTo(scroller, el, smooth) {
    var left = el.offsetLeft - (scroller.clientWidth - el.offsetWidth) / 2;
    if (smooth) scroller.scrollTo({ left: left, behavior: 'smooth' });
    else scroller.scrollLeft = left;
  }

  function init(root) {
    var scroller = root.querySelector('.collection-showcase__scroller');
    if (!scroller || scroller.dataset.coverflowReady) return;
    scroller.dataset.coverflowReady = 'true';

    var real = Array.prototype.slice.call(scroller.children);
    if (real.length < 3) {
      if (real.length) real[Math.floor(real.length / 2)].classList.add('is-active');
      return;
    }

    var headClones = real.slice(0, CLONES).map(function (el) { return el.cloneNode(true); });
    var tailClones = real.slice(-CLONES).map(function (el) { return el.cloneNode(true); });
    tailClones.forEach(function (el) { scroller.insertBefore(el, scroller.firstChild); });
    headClones.forEach(function (el) { scroller.appendChild(el); });

    var all = Array.prototype.slice.call(scroller.children);
    var realStart = CLONES;
    var realEnd = realStart + real.length - 1;

    var scaleRaf = null;
    var settleTimer = null;

    function applyTiers() {
      scaleRaf = null;
      var mid = scroller.scrollLeft + scroller.clientWidth / 2;
      var closestIdx = 0;
      var closestDist = Infinity;
      all.forEach(function (el, i) {
        var dist = Math.abs(centerX(el) - mid);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });
      all.forEach(function (el, i) {
        el.classList.remove('is-active', 'is-near');
        if (i === closestIdx) el.classList.add('is-active');
        else if (Math.abs(i - closestIdx) === 1) el.classList.add('is-near');
      });
      return closestIdx;
    }

    jumpTo(scroller, all[realStart]);
    applyTiers();

    scroller.addEventListener(
      'scroll',
      function () {
        if (scaleRaf == null) scaleRaf = requestAnimationFrame(applyTiers);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var idx = applyTiers();
          // Drifted into a cloned head/tail card — silently reposition to
          // the equivalent real card so the loop reads as infinite.
          if (idx < realStart) {
            jumpTo(scroller, all[idx + real.length]);
            applyTiers();
          } else if (idx > realEnd) {
            jumpTo(scroller, all[idx - real.length]);
            applyTiers();
          }
        }, 120);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      jumpTo(scroller, all[applyTiers()]);
    });

    root.querySelectorAll('.collection-showcase__nav-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = applyTiers();
        var target = btn.dataset.direction === 'next' ? idx + 1 : idx - 1;
        jumpTo(scroller, all[target], true);
      });
    });
  }

  document.querySelectorAll('.collection-showcase').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-promo-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var configEl = document.querySelector('[data-fc-promo-configs]');
    if (!configEl) return;

    var data;
    try {
      data = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var page = data.page || {};
    var variants = data.variants || [];
    if (!variants.length) return;

    function currentHandle() {
      var parts = (page.path || '').replace(/^\//, '').split('/');
      return parts[parts.length - 1] || '';
    }

    function matchesHandles(str) {
      if (!str) return false;
      var handle = currentHandle().toLowerCase();
      return str.split(',').map(function (s) { return s.trim().toLowerCase(); }).indexOf(handle) !== -1;
    }

    var PAGE_TYPE_TARGET_KEY = {
      index: 'targetHomepage',
      collection: 'targetAllCollections',
      product: 'targetAllProducts',
      article: 'targetAllBlogs',
      cart: 'targetCart'
    };

    function matchesPageType(variant) {
      if (variant.targetAllPages) return true;
      var key = PAGE_TYPE_TARGET_KEY[page.type];
      return !!key && !!variant[key];
    }

    function pickVariant() {
      var i;
      for (i = 0; i < variants.length; i++) {
        if (matchesHandles(variants[i].targetHandles)) return variants[i];
      }
      for (i = 0; i < variants.length; i++) {
        if (matchesPageType(variants[i])) return variants[i];
      }
      return null;
    }

    var variant = pickVariant();
    if (!variant) return;

    var root = document.getElementById(variant.id);
    if (!root) return;

    var pill = document.getElementById(variant.id + '-pill');

    if (window.Shopify && Shopify.designMode) {
      // Always show the pill in the editor so its colors can be previewed;
      // clicking it previews the popup.
      if (pill) {
        pill.removeAttribute('hidden');
        pill.addEventListener('click', function (e) {
          if (e.target.closest('[data-fc-promo-pill-open]')) {
            loadEmbeds(function () { root.removeAttribute('hidden'); });
          }
        });
      }
      document.addEventListener('shopify:block:select', function (e) {
        if (('fc-promo-' + e.detail.blockId) === variant.id) {
          loadEmbeds(function () { root.removeAttribute('hidden'); });
        }
      });
      document.addEventListener('shopify:block:deselect', function () {
        root.setAttribute('hidden', '');
      });
      return;
    }

    if (variant.hideOnMobile && window.innerWidth <= 680) return;

    var storageKey = 'fc_promo_seen_' + variant.id;
    var pillKey = 'fc_promo_pill_closed_' + variant.id;

    // Both the auto-open and a closed pill honour the same Show Frequency
    // setting: per session, or for X days.
    function isRemembered(key) {
      try {
        if (variant.frequencyType === 'days') {
          var ts = localStorage.getItem(key);
          if (!ts) return false;
          return (Date.now() - parseInt(ts, 10)) < variant.frequencyDays * 86400000;
        }
        return !!sessionStorage.getItem(key);
      } catch (e) {
        return false;
      }
    }

    function remember(key) {
      try {
        if (variant.frequencyType === 'days') {
          localStorage.setItem(key, String(Date.now()));
        } else {
          sessionStorage.setItem(key, '1');
        }
      } catch (e) {}
    }

    function alreadySeen() {
      return isRemembered(storageKey);
    }

    function markSeen() {
      remember(storageKey);
    }

    var pillClosed = isRemembered(pillKey);

    function updatePill() {
      if (!pill) return;
      var show = !pillClosed && !converted && root.hidden;
      if (show) {
        pill.removeAttribute('hidden');
      } else {
        pill.setAttribute('hidden', '');
      }
    }

    var panel = root.querySelector('.fc-promo__panel');
    var opened = false;
    var opening = false;
    var converted = false;
    var confirmShown = false;
    var leadPollTimer = null;

    /**
     * Starts loading the GHL form + timer, then calls onReady once the form
     * has had a chance to report its real height back to GoHighLevel's embed
     * script (which resizes the iframe via postMessage). The popup stays
     * hidden until onReady fires, so it's never shown at a wrong guessed
     * height that then visibly jumps — a fallback timeout guarantees it
     * still opens if the embed is slow or fails.
     */
    function loadEmbeds(onReady) {
      // The reveal waits on three things: the form's real height, the banner
      // image, and the headline font. Any one landing after the popup is
      // visible changes the panel's height, and on desktop the banner is
      // height: 100% of the panel -- so the image visibly re-crops.
      var pending = 3;
      var revealed = false;
      function done() {
        if (revealed || --pending > 0) return;
        revealed = true;
        onReady();
      }
      // Fallback so a slow network or broken embed can't hide the popup forever.
      setTimeout(function () { pending = 1; done(); }, 2000);

      // The banner is loading="lazy" so visitors who never trigger the popup
      // never download it -- but a lazy image inside a display:none popup
      // won't load until the popup is shown. Flip it to eager and wait for it
      // to decode before revealing.
      var img = root.querySelector('.fc-promo__banner-img');
      if (img) {
        img.loading = 'eager';
        var decoded = img.decode ? img.decode() : null;
        if (decoded) {
          decoded.then(done, done);
        } else if (img.complete) {
          done();
        } else {
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        }
      } else {
        done();
      }

      if (document.fonts && document.fonts.load) {
        document.fonts.load('1em "Archivo Black"').then(done, done);
      } else {
        done();
      }

      loadForm(done);
    }

    function loadForm(onReady) {
      var form = root.querySelector('[data-fc-promo-form]');

      var timerHost = root.querySelector('[data-fc-promo-timer]');
      if (timerHost && !timerHost.dataset.loaded) {
        timerHost.dataset.loaded = '1';
        var timerScript = document.createElement('script');
        timerScript.src = 'https://widgets.leadconnectorhq.com/cdt/remoteEntry.js';
        timerScript.setAttribute('timerId', timerHost.dataset.timerId);
        timerScript.setAttribute('position', timerHost.dataset.timerPosition);
        timerScript.setAttribute('data-v2', 'true');
        timerHost.appendChild(timerScript);
      }

      if (!form) {
        onReady();
        return;
      }

      if (form.getAttribute('src')) {
        onReady();
        return;
      }

      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        onReady();
      }

      form.addEventListener('load', function () {
        // form_embed.js resizes the iframe by postMessage some time after
        // load. Settle once its height has held still for 250ms rather than
        // after a fixed beat, which a slow form can outlast. A
        // MutationObserver on the inline style, not a ResizeObserver: the
        // popup is still display:none here, so there is no box to observe.
        var observer = new MutationObserver(function () {
          clearTimeout(quiet);
          quiet = setTimeout(finish, 250);
        });
        function finish() {
          observer.disconnect();
          settle();
        }
        var quiet = setTimeout(finish, 250);
        observer.observe(form, { attributes: true, attributeFilter: ['style', 'height'] });
      }, { once: true });
      // Same trap as the banner: a lazy iframe inside the hidden popup never
      // loads, so the load event above would only fire after the reveal.
      form.loading = 'eager';
      form.setAttribute('src', form.getAttribute('data-src'));
    }

    // Never show over the mini cart. A trigger that lands while it's open --
    // or while the embeds load, which can take 2s -- waits until it closes.
    var revealAfterCart = false;

    function cartIsOpen() {
      var drawer = document.getElementById('cart-drawer');
      return !!drawer && drawer.hasAttribute('open');
    }

    document.addEventListener('theme-drawer:close', function (e) {
      if (revealAfterCart && e.target.id === 'cart-drawer') {
        revealAfterCart = false;
        reveal();
      }
    });

    // Counted as seen only once it's actually on screen, so a shopper who
    // leaves the page with the cart still open gets it on the next page.
    function reveal() {
      markSeen();
      root.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      updatePill();
      startLeadWatch();
    }

    // Auto triggers open once and respect Show Frequency; the pill passes
    // force so a shopper can reopen the popup whenever they ask for it.
    function open(force) {
      if (!force && (opened || alreadySeen())) return;
      if (opening || revealAfterCart || !root.hidden) return;
      opening = true;
      opened = true;
      loadEmbeds(function () {
        opening = false;
        if (cartIsOpen()) {
          revealAfterCart = true;
        } else {
          reveal();
        }
      });
    }

    function close() {
      root.setAttribute('hidden', '');
      document.body.style.overflow = '';
      stopLeadWatch();
      root.classList.remove('is-confirming');
      updatePill();
    }

    function requestClose() {
      var confirmEl = root.querySelector('[data-fc-promo-confirm]');
      if (variant.enableConfirm && confirmEl && !confirmShown && !converted) {
        confirmShown = true;
        root.classList.add('is-confirming');
        var yesBtn = confirmEl.querySelector('[data-fc-promo-confirm-stay]');
        if (yesBtn) {
          try { yesBtn.focus(); } catch (e) {}
        }
        return;
      }
      close();
    }

    function burstConfetti(hostEl) {
      if (!hostEl) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var colors = ['#80D658', '#EDE9E1', '#f75d44', '#ffd23f'];
      var count = 22;
      var pieces = [];
      for (var i = 0; i < count; i++) {
        var piece = document.createElement('span');
        piece.className = 'fc-promo__confetti';
        piece.style.background = colors[i % colors.length];
        var angle = -Math.PI * (0.12 + (i / count) * 0.76);
        var dist = 120 + (i % 6) * 26;
        piece.style.setProperty('--fc-cx', (Math.cos(angle) * dist) + 'px');
        piece.style.setProperty('--fc-cy', (Math.sin(angle) * dist - 40) + 'px');
        piece.style.setProperty('--fc-cr', (180 + i * 40) + 'deg');
        hostEl.appendChild(piece);
        pieces.push(piece);
      }
      setTimeout(function () {
        pieces.forEach(function (el) {
          if (el.parentNode) el.parentNode.removeChild(el);
        });
      }, 1500);
    }

    function copyToClipboard(text) {
      return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () { return false; });
    }

    function initCopy() {
      var codeWrap = root.querySelector('[data-fc-promo-code]');
      if (!codeWrap) return;
      var valueEl = codeWrap.querySelector('[data-fc-promo-code-value]');
      var labelEl = codeWrap.querySelector('[data-fc-promo-code-copy-label]');
      var statusEl = codeWrap.querySelector('[data-fc-promo-code-status]');
      var code = valueEl ? valueEl.textContent.trim() : '';
      if (!code) return;
      var copyText = labelEl ? labelEl.textContent : 'Copy';
      var copiedText = codeWrap.dataset.copiedText || 'Copied!';
      var wantsConfetti = codeWrap.dataset.confetti === 'true';
      var revertTimer;

      function onCopied() {
        codeWrap.classList.add('is-copied');
        if (labelEl) labelEl.textContent = copiedText;
        if (statusEl) statusEl.textContent = 'Copied to clipboard';
        if (wantsConfetti) burstConfetti(codeWrap);
        clearTimeout(revertTimer);
        revertTimer = setTimeout(function () {
          codeWrap.classList.remove('is-copied');
          if (labelEl) labelEl.textContent = copyText;
          if (statusEl) statusEl.textContent = '';
        }, 2000);
      }

      function doCopy() {
        copyToClipboard(code).then(function (ok) { if (ok) onCopied(); });
      }

      var copyBtn = codeWrap.querySelector('[data-fc-promo-code-copy]');
      if (copyBtn) copyBtn.addEventListener('click', doCopy);
      if (valueEl) valueEl.addEventListener('click', doCopy);
    }

    function onConverted() {
      if (converted) return;
      converted = true;
      stopLeadWatch();

      if (!variant.showSuccess) {
        close();
        return;
      }

      root.classList.add('is-converted');

      var countdownEl = root.querySelector('[data-fc-promo-countdown]');
      var delay = variant.autoCloseDelay;
      var remaining = Math.round(delay / 1000);
      var tick;

      function updateCountdown() {
        if (!countdownEl) return;
        var template = countdownEl.getAttribute('data-template') || '';
        countdownEl.textContent = template.replace('{s}', remaining);
      }

      if (countdownEl) {
        updateCountdown();
        if (delay > 0) {
          tick = setInterval(function () {
            remaining = Math.max(0, remaining - 1);
            updateCountdown();
            if (remaining <= 0) clearInterval(tick);
          }, 1000);
        }
      }

      if (delay > 0) {
        setTimeout(function () {
          clearInterval(tick);
          close();
        }, delay);
      }
    }

    function ghlLeadCollected() {
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var value = localStorage.getItem(localStorage.key(i)) || '';
          if (value.indexOf('leadCollected') > -1 && /"leadCollected"\s*:\s*true/i.test(value)) return true;
        }
      } catch (e) {}
      return false;
    }

    function startLeadWatch() {
      if (leadPollTimer) return;
      var alreadyConverted = ghlLeadCollected();
      leadPollTimer = setInterval(function () {
        if (!alreadyConverted && ghlLeadCollected()) {
          stopLeadWatch();
          onConverted();
        }
      }, 600);
    }

    function stopLeadWatch() {
      if (leadPollTimer) {
        clearInterval(leadPollTimer);
        leadPollTimer = null;
      }
    }

    var GHL_HOSTS = ['leadconnectorhq.com', 'msgsndr.com', 'gohighlevel.com'];

    function isGHLOrigin(origin) {
      var hostname;
      try {
        hostname = new URL(origin).hostname.toLowerCase();
      } catch (e) {
        return false;
      }
      return GHL_HOSTS.some(function (host) {
        return hostname === host || hostname.slice(-(host.length + 1)) === ('.' + host);
      });
    }

    window.addEventListener('message', function (e) {
      if (!e.data) return;
      if (!isGHLOrigin(e.origin || '')) return;

      var blob = typeof e.data === 'string' ? e.data.toLowerCase() : JSON.stringify(e.data).toLowerCase();
      var isSubmit = blob.indexOf('customer_id') > -1 ||
        blob.indexOf('formsubmitted') > -1 ||
        blob.indexOf('form-submitted') > -1 ||
        (blob.indexOf('"email"') > -1 && blob.indexOf('full_name') > -1);

      if (isSubmit) onConverted();
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fc-promo-dismiss]')) {
        requestClose();
        return;
      }
      if (e.target.closest('[data-fc-promo-dismiss-final]')) {
        close();
        return;
      }
      if (e.target.closest('[data-fc-promo-confirm-stay]')) {
        burstConfetti(root.querySelector('[data-fc-promo-confirm]'));
        setTimeout(function () { root.classList.remove('is-confirming'); }, 1200);
        return;
      }
      if (variant.closeOnOverlay && e.target === root) {
        requestClose();
      }
    });

    if (variant.closeOnEsc) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) requestClose();
      });
    }

    initCopy();

    var stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    if (pill && stickyBar && window.ResizeObserver) {
      new ResizeObserver(function () {
        pill.style.setProperty('--fc-sticky-atc-height', stickyBar.offsetHeight + 'px');
      }).observe(stickyBar);
    }

    if (pill) {
      // Someone who already signed up on an earlier visit has no use for it.
      if (ghlLeadCollected()) pillClosed = true;

      pill.addEventListener('click', function (e) {
        if (e.target.closest('[data-fc-promo-pill-close]')) {
          pillClosed = true;
          remember(pillKey);
          updatePill();
          return;
        }
        if (e.target.closest('[data-fc-promo-pill-open]')) open(true);
      });

      updatePill();
    }

    if (!variant.autoOpen) return;

    if (variant.openDelay >= 0) setTimeout(function () { open(); }, variant.openDelay);

    if (variant.exitIntent) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) open();
      });
    }

    if (variant.triggerScroll) {
      var scrollFired = false;
      window.addEventListener('scroll', function () {
        if (scrollFired) return;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
        if (pct >= variant.triggerScrollPercent) {
          scrollFired = true;
          open();
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fc-reviews').forEach(function (root) {
    var scroller = root.querySelector('.fc-reviews__carousel');
    var navButtons = root.querySelectorAll('.fc-reviews__nav-btn');
    if (!scroller || !navButtons.length) return;

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = scroller.querySelector('.fc-reviews__card');
        var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
        var step = card ? card.offsetWidth + gap : scroller.clientWidth;
        scroller.scrollBy({
          left: btn.dataset.direction === 'next' ? step : -step,
          behavior: 'smooth',
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-scratch-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var configEl = document.querySelector('[data-fc-scratch-configs]');
    if (!configEl) return;

    var data;
    try {
      data = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var page = data.page || {};
    var variants = data.variants || [];
    if (!variants.length) return;

    function currentHandle() {
      var parts = (page.path || '').replace(/^\//, '').split('/');
      return parts[parts.length - 1] || '';
    }

    function matchesHandles(str) {
      if (!str) return false;
      var handle = currentHandle().toLowerCase();
      return str.split(',').map(function (s) { return s.trim().toLowerCase(); }).indexOf(handle) !== -1;
    }

    var PAGE_TYPE_TARGET_KEY = {
      index: 'targetHomepage',
      collection: 'targetAllCollections',
      product: 'targetAllProducts',
      article: 'targetAllBlogs',
      cart: 'targetCart'
    };

    function matchesPageType(variant) {
      var key = PAGE_TYPE_TARGET_KEY[page.type];
      return !!key && !!variant[key];
    }

    function pickVariant() {
      var i;
      for (i = 0; i < variants.length; i++) {
        if (matchesHandles(variants[i].targetHandles)) return variants[i];
      }
      for (i = 0; i < variants.length; i++) {
        if (matchesPageType(variants[i])) return variants[i];
      }
      return null;
    }

    var variant = pickVariant();
    if (!variant) return;

    var root = document.getElementById(variant.id);
    if (!root) return;

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (('fc-scratch-' + e.detail.blockId) === variant.id) {
          root.removeAttribute('hidden');
          setupScratch();
        }
      });
      document.addEventListener('shopify:block:deselect', function () {
        root.setAttribute('hidden', '');
      });
      return;
    }

    if (variant.hideOnMobile && window.innerWidth <= 680) return;

    var storageKey = 'fc_scratch_seen_' + variant.id;

    function alreadySeen() {
      try {
        if (variant.frequencyType === 'days') {
          var ts = localStorage.getItem(storageKey);
          if (!ts) return false;
          return (Date.now() - parseInt(ts, 10)) < variant.frequencyDays * 86400000;
        }
        return !!sessionStorage.getItem(storageKey);
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try {
        if (variant.frequencyType === 'days') {
          localStorage.setItem(storageKey, String(Date.now()));
        } else {
          sessionStorage.setItem(storageKey, '1');
        }
      } catch (e) {}
    }

    var opened = false;
    var converted = false;
    var leadPollTimer = null;
    var scratchApi = null;

    function open() {
      if (opened || alreadySeen()) return;
      opened = true;
      markSeen();
      root.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setupScratch();
    }

    function close() {
      root.setAttribute('hidden', '');
      document.body.style.overflow = '';
      stopLeadWatch();
    }

    function setupScratch() {
      if (scratchApi) return;
      var card = root.querySelector('[data-fc-scratch-card]');
      if (!card) return;
      scratchApi = initScratch(card);
    }

    /**
     * Canvas "foil" sits absolutely over the already-rendered prize content
     * and is erased via destination-out compositing as the visitor drags.
     * Cleared-ratio is sampled on a throttled rAF tick (not every pointermove)
     * to keep this cheap on low-end mobile devices.
     */
    function initScratch(card) {
      var canvas = card.querySelector('[data-fc-scratch-canvas]');
      var revealBtn = root.querySelector('[data-fc-scratch-reveal]');
      var revealed = false;

      if (!canvas || !canvas.getContext) {
        card.classList.add('is-revealed');
        if (revealBtn) revealBtn.hidden = true;
        return {};
      }

      var ctx = canvas.getContext('2d');
      var rootStyle = getComputedStyle(root);
      var c1 = rootStyle.getPropertyValue('--fc-scratch-surface-1').trim() || '#9BE377';
      var label = canvas.getAttribute('data-label') || 'SCRATCH HERE';
      var dpr = Math.min(window.devicePixelRatio || 1, 2);

      function paint() {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = c1;
        ctx.fillRect(0, 0, rect.width, rect.height);
        ctx.font = '700 12px Archivo, sans-serif';
        ctx.fillStyle = 'rgba(255,255,255,.55)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(label, rect.width / 2, rect.height / 2);
      }

      function erase(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, 24, 0, Math.PI * 2);
        ctx.fill();
      }

      function clearedRatio() {
        var w = canvas.width, h = canvas.height;
        if (!w || !h) return 0;
        var pixels = ctx.getImageData(0, 0, w, h).data;
        var sampled = 0, cleared = 0;
        for (var i = 3; i < pixels.length; i += 4 * 12) {
          sampled++;
          if (pixels[i] < 60) cleared++;
        }
        return sampled ? cleared / sampled : 0;
      }

      var pending = false;
      function scheduleCheck() {
        if (pending || revealed) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          if (clearedRatio() > .5) fireRevealed();
        });
      }

      function fireRevealed() {
        if (revealed) return;
        revealed = true;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        canvas.style.transition = reduceMotion ? 'none' : 'opacity .45s ease';
        canvas.style.opacity = '0';
        canvas.style.pointerEvents = 'none';
        card.classList.add('is-revealed');
        setTimeout(function () { canvas.hidden = true; }, reduceMotion ? 0 : 450);

        if (!reduceMotion && navigator.vibrate) navigator.vibrate(10);

        if (reduceMotion) {
          var valueEl = card.querySelector('.fc-scratch__prize-value');
          if (valueEl) {
            valueEl.classList.add('fc-scratch--pulse');
            setTimeout(function () { valueEl.classList.remove('fc-scratch--pulse'); }, 600);
          }
        } else if (card.dataset.confetti === 'true') {
          burstConfetti();
        }
      }

      function localPos(e) {
        var rect = canvas.getBoundingClientRect();
        return { x: e.clientX - rect.left, y: e.clientY - rect.top };
      }

      var drawing = false;
      canvas.addEventListener('pointerdown', function (e) {
        drawing = true;
        var p = localPos(e);
        erase(p.x, p.y);
        scheduleCheck();
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!drawing) return;
        var p = localPos(e);
        erase(p.x, p.y);
        scheduleCheck();
      });
      window.addEventListener('pointerup', function () { drawing = false; });
      window.addEventListener('pointercancel', function () { drawing = false; });

      if (revealBtn) revealBtn.addEventListener('click', fireRevealed);

      paint();
      window.addEventListener('resize', debounce(function () {
        if (!revealed) paint();
      }, 200));

      return { reveal: fireRevealed };
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        var args = arguments;
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    var CONFETTI_COLORS = ['#80D658', '#EDE9E1', '#9BE377', '#4E8F2F', '#FFD23F'];
    var CONFETTI_WEIGHTS = [.35, .60, .80, .90, 1];

    function confettiColor() {
      var r = Math.random();
      for (var i = 0; i < CONFETTI_WEIGHTS.length; i++) {
        if (r < CONFETTI_WEIGHTS[i]) return CONFETTI_COLORS[i];
      }
      return CONFETTI_COLORS[CONFETTI_COLORS.length - 1];
    }

    function confettiShape() {
      var r = Math.random();
      if (r < .5) return { w: 9, h: 14, radius: '2px' };
      if (r < .8) return { w: 7, h: 7, radius: '50%' };
      return { w: 4, h: 16, radius: '2px' };
    }

    function spawnConfettiPiece(overlay, x, y, animName, duration, delay, props) {
      var shape = confettiShape();
      var piece = document.createElement('span');
      piece.style.position = 'absolute';
      piece.style.left = x + 'px';
      piece.style.top = y + 'px';
      piece.style.width = shape.w + 'px';
      piece.style.height = shape.h + 'px';
      piece.style.borderRadius = shape.radius;
      piece.style.background = confettiColor();
      for (var key in props) piece.style.setProperty(key, props[key]);
      piece.style.animation = animName + ' ' + duration.toFixed(0) + 'ms cubic-bezier(.15,.6,.35,1) ' + delay.toFixed(0) + 'ms both';
      overlay.appendChild(piece);
      setTimeout(function () {
        if (piece.parentNode) piece.parentNode.removeChild(piece);
      }, delay + duration + 60);
    }

    function spawnCannon(overlay, x, y, angleMinDeg, angleMaxDeg) {
      for (var i = 0; i < 24; i++) {
        var angle = (angleMinDeg + Math.random() * (angleMaxDeg - angleMinDeg)) * Math.PI / 180;
        var apexDist = 130 + Math.random() * 150;
        var apexX = Math.cos(angle) * apexDist;
        var apexY = Math.sin(angle) * apexDist;
        var endX = apexX + Math.cos(angle) * (40 + Math.random() * 40);
        var endY = apexY + 70 + Math.random() * 100;
        var rot = (Math.random() < 0.5 ? -1 : 1) * (180 + Math.random() * 360);
        spawnConfettiPiece(overlay, x, y, 'fc-scratch-confetti-burst', 1200 + Math.random() * 500, Math.random() * 150, {
          '--fc-apex-x': apexX.toFixed(1) + 'px',
          '--fc-apex-y': apexY.toFixed(1) + 'px',
          '--fc-end-x': endX.toFixed(1) + 'px',
          '--fc-end-y': endY.toFixed(1) + 'px',
          '--fc-r': rot.toFixed(0) + 'deg'
        });
      }
    }

    function spawnRain(overlay) {
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      for (var i = 0; i < 18; i++) {
        var rot = (Math.random() < 0.5 ? -1 : 1) * (120 + Math.random() * 240);
        spawnConfettiPiece(overlay, Math.random() * vw, -20, 'fc-scratch-confetti-rain', 1800 + Math.random() * 600, Math.random() * 400, {
          '--fc-wobble': ((Math.random() - 0.5) * 30).toFixed(1) + 'px',
          '--fc-fall': (vh + 40).toFixed(0) + 'px',
          '--fc-r': rot.toFixed(0) + 'deg'
        });
      }
    }

    function burstConfetti() {
      var vw = window.innerWidth;
      var vh = window.innerHeight;

      var overlay = document.createElement('div');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:10000;overflow:hidden;';
      document.body.appendChild(overlay);

      spawnCannon(overlay, -10, vh * 0.7, -80, -20);
      spawnCannon(overlay, vw + 10, vh * 0.7, -160, -100);
      setTimeout(function () { spawnRain(overlay); }, 200);

      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 3200);
    }

    var mainStep = root.querySelector('[data-fc-scratch-step="main"]');
    var emailStep = root.querySelector('[data-fc-scratch-step="email"]');
    var claimBtn = root.querySelector('[data-fc-scratch-claim]');

    function showEmailStep() {
      if (mainStep) mainStep.hidden = true;
      if (emailStep) emailStep.hidden = false;
      loadGhlIfNeeded();
      startLeadWatch();
    }

    if (claimBtn) claimBtn.addEventListener('click', showEmailStep);

    function loadGhlIfNeeded() {
      var form = root.querySelector('[data-fc-scratch-ghl-form]');
      if (!form || form.getAttribute('src')) return;
      form.setAttribute('src', form.getAttribute('data-src'));
    }

    var GHL_HOSTS = ['leadconnectorhq.com', 'msgsndr.com', 'gohighlevel.com'];

    function isGHLOrigin(origin) {
      var hostname;
      try {
        hostname = new URL(origin).hostname.toLowerCase();
      } catch (e) {
        return false;
      }
      return GHL_HOSTS.some(function (host) {
        return hostname === host || hostname.slice(-(host.length + 1)) === ('.' + host);
      });
    }

    function ghlLeadCollected() {
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var value = localStorage.getItem(localStorage.key(i)) || '';
          if (value.indexOf('leadCollected') > -1 && /"leadCollected"\s*:\s*true/i.test(value)) return true;
        }
      } catch (e) {}
      return false;
    }

    function startLeadWatch() {
      if (leadPollTimer || !root.querySelector('[data-fc-scratch-ghl-form]')) return;
      leadPollTimer = setInterval(function () {
        if (ghlLeadCollected()) {
          stopLeadWatch();
          onConverted();
        }
      }, 600);
    }

    function stopLeadWatch() {
      if (leadPollTimer) {
        clearInterval(leadPollTimer);
        leadPollTimer = null;
      }
    }

    window.addEventListener('message', function (e) {
      if (!e.data) return;
      if (!isGHLOrigin(e.origin || '')) return;
      var blob = typeof e.data === 'string' ? e.data.toLowerCase() : JSON.stringify(e.data).toLowerCase();
      var isSubmit = blob.indexOf('customer_id') > -1 ||
        blob.indexOf('formsubmitted') > -1 ||
        blob.indexOf('form-submitted') > -1 ||
        (blob.indexOf('"email"') > -1 && blob.indexOf('full_name') > -1);
      if (isSubmit) onConverted();
    });

    var fallbackForm = root.querySelector('.fc-scratch__fallback-form');
    if (fallbackForm) {
      fallbackForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = fallbackForm.querySelector('button[type="submit"]');
        var errorEl = root.querySelector('[data-fc-scratch-fallback-error]');
        if (btn) btn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(fallbackForm)).toString()
        }).then(function (res) {
          if (!res.ok) throw new Error('bad status');
          onConverted();
        }).catch(function () {
          if (btn) btn.disabled = false;
          if (errorEl) errorEl.hidden = false;
        });
      });
    }

    function onConverted() {
      if (converted) return;
      converted = true;
      stopLeadWatch();
      if (!variant.showSuccess) {
        close();
        return;
      }
      if (mainStep) mainStep.hidden = true;
      if (emailStep) emailStep.hidden = true;
      root.classList.add('is-converted');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fc-scratch-dismiss]')) {
        close();
        return;
      }
      if (e.target.closest('[data-fc-scratch-dismiss-final]')) {
        close();
        return;
      }
      if (variant.closeOnOverlay && e.target === root) {
        close();
      }
    });

    if (variant.closeOnEsc) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !root.hidden) close();
      });
    }

    if (variant.openDelay >= 0) setTimeout(open, variant.openDelay);

    if (variant.exitIntent) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) open();
      });
    }

    if (variant.triggerScroll) {
      var scrollFired = false;
      window.addEventListener('scroll', function () {
        if (scrollFired) return;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
        if (pct >= variant.triggerScrollPercent) {
          scrollFired = true;
          open();
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-fc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fc-footer__nl-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var wrapper = form.closest('.fc-footer__newsletter');
        var successEl = wrapper ? wrapper.querySelector('.fc-footer__nl-success') : null;
        var errorEl = wrapper ? wrapper.querySelector('.fc-footer__nl-error') : null;
        if (btn) btn.disabled = true;
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString(),
        }).then(function () {
          form.hidden = true;
          if (successEl) successEl.hidden = false;
        }).catch(function () {
          if (btn) btn.disabled = false;
          if (errorEl) errorEl.hidden = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
